import { parseArrayQueryParam } from "../helpers/parseArrayQueryParam.js";
const listTasks = (axios) => async (params, signal) => {
  var _a, _b;
  const { data } = await axios.get("/api/tasks/", {
    signal,
    params: {
      ...params,
      statuses: parseArrayQueryParam(params.statuses),
      origins: parseArrayQueryParam(params.origins),
      sort: `${(_a = params.sort) == null ? void 0 : _a.sortBy},${(_b = params.sort) == null ? void 0 : _b.order}`
    }
  });
  return data;
};
const openTasksCount = (axios) => async (params) => {
  const { data } = await axios.get("/api/tasks/size/", {
    params: {
      clinicReferenceId: params.clinicReferenceId,
      statuses: parseArrayQueryParam(params.statuses)
    }
  });
  return data;
};
const getTask = (axios) => async ({ referenceId }) => {
  const { data } = await axios.get(`/api/tasks/${referenceId}`);
  return data;
};
const updateTask = (axios) => async (id, task) => {
  const { data } = await axios.put(`/api/tasks/${id}`, task);
  return data;
};
export {
  getTask,
  listTasks,
  openTasksCount,
  updateTask
};
